module.exports = "<div class=\"row\">\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\r\n        <label class=\"pull-left\">\r\n            <h4 class=\"f-s-b m-b-10 m-t-20\">{{currentLanguageSet?.agentStatus}}</h4>\r\n        </label>\r\n    </div>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\r\n        <iframe [src]=\"agentStatusURL\" width=\"100%\" height=\"700px\" title=\"agentStatus\"></iframe>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/agent-status/agent-status.component.html
// module id = ../../../../../src/app/agent-status/agent-status.component.html
// module chunks = 0